'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-pure.js
// module id = 27
// module chunks = 0